import React, { useEffect, useState, useRef } from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess } from "../../../common/Toast";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import * as XLSX from "xlsx";
import DemoPic from "../../../assets/img/download.png";
import moment from "moment";

const JobWorkReceipt = (props) => {
  const token = localStorage.getItem("Token");
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [selectedId, setSelectedId] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [salesItem, setSalesItem] = useState([]);
  const [salesdetails, setSalesDetails] = useState([]);

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  console.log(salesdetails, "salesdetails");

  //Function for downloading pdf of barcodesheet
  const downloadPdf = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    const pdf = new jsPDF();
    responseData.SalesItems?.forEach((item) => {
      // Generate barcode for the current item
      const barcodeRef = barcodeRefs.current[item.SaleId];
      const barcodeValue = `${item.SaleId}`;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        // barcode options
      });

      // Add barcode to PDF
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addPage();
    });
    pdf.deletePage(responseData.SalesItems?.length + 1); // Remove extra page added by addPage() method
    pdf.save("barcodes.pdf");
  };

  console.log("salesItem 95", salesItem);
  //Function for print
  // pdf download
  const handlePrint = () => {
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";
    clonedHeader.style.marginTop = "0rem";
    clonedHeader.style.padding = "0";
    clonedHeader.style.color = "#000";
    clonedHeader.style.wordSpacing = "3px";

    // Add the footer
    let footerElement = document.querySelector("#footer");
    let clonedFooter = footerElement.cloneNode(true);
    clonedFooter.style.fontSize = `10px`;
    clonedFooter.style.width = "560px";
    clonedFooter.style.margin = "0.5rem";
    clonedFooter.style.marginBottom = "2rem";
    clonedFooter.style.paddingBottom = "1rem";
    clonedFooter.style.borderBottom = "1px solid black";

    let content = "";
    let startIndex = 1;
    let endIndex = 10;
    let carryOverSum = 0;

    for (var i = 1; i <= Math.ceil(salesItem.length / 10); i++) {
      // Printing page no-
      let pageNoElement = clonedHeader.querySelector("#page-no");
      pageNoElement.innerText = i;

      content +=
        ' <div style="text-align: end; font-size: 10px; font-weight:bold; width:580px; margin-top:2px ">Original</div>';

      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Condition based Css-
      content +=
        '<div style="width: 580px; height: 280px; border-bottom: 1px solid black;">';
      // if (i > 1) {
      //   content +=
      //     '<div style="width: 580px "><p style="font-weight: bold; font-size: 7px; text-align: right;">Carry Over: ' +
      //     carryOverSum.toFixed(2) +
      //     "<p></div>";
      // }
      if (i == 1) {
        clonedHeader.style.marginTop = "1rem";
        // clonedFooter.style.marginTop = "1rem";
      }
      if (i > 1 && i != Math.ceil(salesItem.length / 10)) {
        // clonedFooter.style.marginTop = "1.4rem";
      }

      // Checking remaining Loops printing last footer-
      if (i == Math.ceil(salesItem.length / 10)) {
        let remainItems = Number(salesItem.length) % 10;
        let remainLoop = 10 - remainItems;

        // clonedFooter.style.marginTop = `${remainLoop * 1.9}rem`;
      }

      // Printing table body-
      content +=
        '<table style="font-size: 10px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">S.No</th>' +
        '<th style="padding: 8px; width: 300px">Description</th>' +
        // '<th style="padding: 8px;">Barcode</th>' +
        '<th style="padding: 8px;">Quantity</th>' +
        '<th style="padding: 8px;">Price</th>' +
        '<th style="padding: 8px;">Discount%</th>' +
        // '<th style="padding: 8px;">Tax%</th>' +
        '<th style="padding: 8px;">Total</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= salesItem.length) {
          content +=
            "<tr>" +
            // First row
            "<tr>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px 0px 8px;  text-align: center;">' +
            index +
            "</td>" +
            '<td colspan="6" style="font-size: 10px; font-weight: bold; padding: 0px 8px; z-index: 1; width: 560px">' +
            '<p style="font-size: 10px; font-weight: bold; margin: 0">' +
            (salesItem[index - 1]?.ItemName
              ? salesItem[index - 1]?.ItemName
              : "") +
            (salesItem[index - 1].ItemVariationName
              ? salesItem[index - 1].ItemVariationName
              : "") +
            // <strong>{item?.ItemName}:</strong>
            // <strong>{item?.ItemVariationName}</strong>
            "</p>" +
            "<span>" +
            (salesItem[index - 1].Itemnumber
              ? salesItem[index - 1].Itemnumber
              : "") +
            "</span>" +
            "</td>" +
            "</tr>" +
            // Second row
            "<tr>" +
            // '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;"></td>' +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;"></td>' +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;"></td>' +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Quantity).toFixed(2) +
            "</td>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Price).toFixed(2) +
            "</td>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Discount).toFixed(2) +
            "</td>" +
            // '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            // Number(salesItem[index - 1].Tax).toFixed(2) +
            // "</td>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Total).toFixed(2) +
            "</td>" +
            "</tr>" +
            "</tr>";

          // Add the "Total" value to the carryOverSum on each page
          carryOverSum += Number(salesItem[index - 1].Total);
        }

        if (index % 10 == 0) {
          startIndex = startIndex + 10;
          endIndex = endIndex + 10;
          break;
        }
      }

      // Printing Total or Carry Sum condition based-
      // if (i !== Math.ceil(salesItem.length / 10)) {
      //   content +=
      //     '<tr><td colspan="12" style="text-align: right; padding-right: 10px; font-weight: bold;">Carry Over: ' +
      //     carryOverSum.toFixed(2) +
      //     "</td></tr>";
      // } else {
      content +=
        '<tr><td colspan="12" style="text-align: right; padding-top: 1rem; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Sub Total: ' +
        Number(salesdetails[0]?.SubTotal).toFixed(2) +
        "</td></tr>";

      // content +=
      //   '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Tax: ' +
      //   Number(salesdetails[0]?.Tax).toFixed(2) +
      //   "</td></tr>";

      content +=
        '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Discount: ' +
        Number(salesdetails[0]?.Discount).toFixed(2) +
        "</td></tr>";

      content +=
        '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Total: ' +
        Number(salesdetails[0]?.Total).toFixed(2) +
        "</td></tr>";
      // }

      content += "</tbody>";
      content += "</table>";

      // Printing footer-
      // content += " " + clonedFooter.outerHTML;
      // content += " " + clonedFooter.style.borderBottom = "solid black";
      content += "</div>";
      // '<div style="border: 1px solid black; padding-bottom: 3rem;"></div>';
    }
    // setIsOriginal(false);

    let startI = 1;
    let endI = 10;

    for (var i = 1; i <= Math.ceil(salesItem.length / 10); i++) {
      // Printing page no-
      let pageNoElement = clonedHeader.querySelector("#page-no");
      pageNoElement.innerText = i;

      content +=
        ' <div style="text-align: end; font-size: 10px; font-weight:bold; width:580px; margin-top:2px ">Duplicate</div>';

      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Condition based Css-
      content +=
        '<div style="width: 580px; height: 280px; border-bottom: 1px solid black;">';
      // if (i > 1) {
      //   content +=
      //     '<div style="width: 580px "><p style="font-weight: bold; font-size: 7px; text-align: right;">Carry Over: ' +
      //     carryOverSum.toFixed(2) +
      //     "<p></div>";
      // }
      if (i == 1) {
        clonedHeader.style.marginTop = "1rem";
        // clonedFooter.style.marginTop = "1rem";
      }
      if (i > 1 && i != Math.ceil(salesItem.length / 10)) {
        // clonedFooter.style.marginTop = "1.4rem";
      }

      // Checking remaining Loops printing last footer-
      if (i == Math.ceil(salesItem.length / 10)) {
        let remainItems = Number(salesItem.length) % 10;
        let remainLoop = 10 - remainItems;

        // clonedFooter.style.marginTop = `${remainLoop * 1.9}rem`;
      }

      // Printing table body-
      content +=
        '<table style="font-size: 10px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">S.No</th>' +
        '<th style="padding: 8px; width: 300px">Description</th>' +
        // '<th style="padding: 8px;">Barcode</th>' +
        '<th style="padding: 8px;">Quantity</th>' +
        '<th style="padding: 8px;">Price</th>' +
        '<th style="padding: 8px;">Discount%</th>' +
        // '<th style="padding: 8px;">Tax%</th>' +
        '<th style="padding: 8px;">Total</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startI; index <= endI; index++) {
        if (index >= startI && index <= salesItem.length) {
          content +=
            "<tr>" +
            // First row
            "<tr>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px 0px 8px;  text-align: center;;">' +
            index +
            "</td>" +
            '<td colspan="6" style="font-size: 10px; font-weight: bold; padding: 0px 8px; z-index: 1; width: 560px">' +
            '<p style="font-size: 10px; font-weight: bold; font-weight: bold; margin: 0">' +
            salesItem[index - 1]?.ItemName +
            salesItem[index - 1].ItemVariationName +
            // <strong>{item?.ItemName}:</strong>
            // <strong>{item?.ItemVariationName}</strong>
            "</p>" +
            "<span>" +
            salesItem[index - 1].Itemnumber +
            "</span>" +
            "</td>" +
            "</tr>" +
            // Second row
            "<tr>" +
            // '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;"></td>' +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;"></td>' +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;"></td>' +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Quantity).toFixed(2) +
            "</td>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Price).toFixed(2) +
            "</td>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Discount).toFixed(2) +
            "</td>" +
            // '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            // Number(salesItem[index - 1].Tax).toFixed(2) +
            // "</td>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Total).toFixed(2) +
            "</td>" +
            "</tr>" +
            "</tr>";

          // Add the "Total" value to the carryOverSum on each page
          carryOverSum += Number(salesItem[index - 1].Total);
        }

        if (index % 10 == 0) {
          startI = startI + 10;
          endI = endI + 10;
          break;
        }
      }

      // Printing Total or Carry Sum condition based-
      // if (i !== Math.ceil(salesItem.length / 10)) {
      //   content +=
      //     '<tr><td colspan="12" style="text-align: right; padding-right: 10px; font-weight: bold;">Carry Over: ' +
      //     carryOverSum.toFixed(2) +
      //     "</td></tr>";
      // } else {
      content +=
        '<tr><td colspan="12" style="text-align: right; padding-top: 1rem; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Sub Total: ' +
        Number(salesdetails[0]?.SubTotal).toFixed(2) +
        "</td></tr>";

      // content +=
      //   '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Tax: ' +
      //   Number(salesdetails[0]?.Tax).toFixed(2) +
      //   "</td></tr>";

      content +=
        '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Discount: ' +
        Number(salesdetails[0]?.Discount).toFixed(2) +
        "</td></tr>";

      content +=
        '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Total: ' +
        Number(salesdetails[0]?.Total).toFixed(2) +
        "</td></tr>";
      // }

      content += "</tbody>";
      content += "</table>";

      // Printing footer-
      // content += " " + clonedFooter.outerHTML;
      // content += " " + clonedFooter.style.borderBottom = "solid black";
      content += "</div>";
      // '<div style="border: 1px solid black; padding-bottom: 3rem;"></div>';
    }

    setLoading(false);
    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        pdf.output("dataurlnewwindow");
      },
    });
  };

  //Function for download
  const handleDownload = () => {
    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";
    clonedHeader.style.marginTop = "0rem";
    clonedHeader.style.padding = "0";
    clonedHeader.style.color = "#000";
    clonedHeader.style.wordSpacing = "3px";

    // Add the footer
    let footerElement = document.querySelector("#footer");
    let clonedFooter = footerElement.cloneNode(true);
    clonedFooter.style.fontSize = `10px`;
    clonedFooter.style.width = "560px";
    clonedFooter.style.margin = "0.5rem";
    clonedFooter.style.marginBottom = "2rem";
    clonedFooter.style.paddingBottom = "1rem";
    clonedFooter.style.borderBottom = "1px solid black";

    let content = "";
    let startIndex = 1;
    let endIndex = 10;
    let carryOverSum = 0;

    for (var i = 1; i <= Math.ceil(salesItem.length / 10); i++) {
      // Printing page no-
      let pageNoElement = clonedHeader.querySelector("#page-no");
      pageNoElement.innerText = i;

      content +=
        ' <div style="text-align: end; font-size: 10px; font-weight:bold; width:580px; margin-top:2px ">Original</div>';

      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Condition based Css-
      content +=
        '<div style="width: 580px; height: 280px; border-bottom: 1px solid black;">';
      // if (i > 1) {
      //   content +=
      //     '<div style="width: 580px "><p style="font-weight: bold; font-size: 7px; text-align: right;">Carry Over: ' +
      //     carryOverSum.toFixed(2) +
      //     "<p></div>";
      // }
      if (i == 1) {
        clonedHeader.style.marginTop = "1rem";
        // clonedFooter.style.marginTop = "1rem";
      }
      if (i > 1 && i != Math.ceil(salesItem.length / 10)) {
        // clonedFooter.style.marginTop = "1.4rem";
      }

      // Checking remaining Loops printing last footer-
      if (i == Math.ceil(salesItem.length / 10)) {
        let remainItems = Number(salesItem.length) % 10;
        let remainLoop = 10 - remainItems;

        // clonedFooter.style.marginTop = `${remainLoop * 1.9}rem`;
      }

      // Printing table body-
      content +=
        '<table style="font-size: 10px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">S.No</th>' +
        '<th style="padding: 8px; width: 300px">Description</th>' +
        // '<th style="padding: 8px;">Barcode</th>' +
        '<th style="padding: 8px;">Quantity</th>' +
        '<th style="padding: 8px;">Price</th>' +
        '<th style="padding: 8px;">Discount%</th>' +
        // '<th style="padding: 8px;">Tax%</th>' +
        '<th style="padding: 8px;">Total</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startIndex; index <= endIndex; index++) {
        if (index >= startIndex && index <= salesItem.length) {
          content +=
            "<tr>" +
            // First row
            "<tr>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px 0px 8px;  text-align: center;">' +
            index +
            "</td>" +
            '<td colspan="6" style="font-size: 10px; font-weight: bold; padding: 0px 8px; z-index: 1; width: 560px">' +
            '<p style="font-size: 10px; font-weight: bold; margin: 0">' +
            (salesItem[index - 1]?.ItemName
              ? salesItem[index - 1]?.ItemName
              : "") +
            (salesItem[index - 1].ItemVariationName
              ? salesItem[index - 1].ItemVariationName
              : "") +
            // <strong>{item?.ItemName}:</strong>
            // <strong>{item?.ItemVariationName}</strong>
            "</p>" +
            "<span>" +
            (salesItem[index - 1].Itemnumber
              ? salesItem[index - 1].Itemnumber
              : "") +
            "</span>" +
            "</td>" +
            "</tr>" +
            // Second row
            "<tr>" +
            // '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;"></td>' +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;"></td>' +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;"></td>' +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Quantity).toFixed(2) +
            "</td>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Price).toFixed(2) +
            "</td>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Discount).toFixed(2) +
            "</td>" +
            // '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            // Number(salesItem[index - 1].Tax).toFixed(2) +
            // "</td>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Total).toFixed(2) +
            "</td>" +
            "</tr>" +
            "</tr>";

          // Add the "Total" value to the carryOverSum on each page
          carryOverSum += Number(salesItem[index - 1].Total);
        }

        if (index % 10 == 0) {
          startIndex = startIndex + 10;
          endIndex = endIndex + 10;
          break;
        }
      }

      // Printing Total or Carry Sum condition based-
      // if (i !== Math.ceil(salesItem.length / 10)) {
      //   content +=
      //     '<tr><td colspan="12" style="text-align: right; padding-right: 10px; font-weight: bold;">Carry Over: ' +
      //     carryOverSum.toFixed(2) +
      //     "</td></tr>";
      // } else {
      content +=
        '<tr><td colspan="12" style="text-align: right; padding-top: 1rem; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Sub Total: ' +
        Number(salesdetails[0]?.SubTotal).toFixed(2) +
        "</td></tr>";

      // content +=
      //   '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Tax: ' +
      //   Number(salesdetails[0]?.Tax).toFixed(2) +
      //   "</td></tr>";

      content +=
        '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Discount: ' +
        Number(salesdetails[0]?.Discount).toFixed(2) +
        "</td></tr>";

      content +=
        '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Total: ' +
        Number(salesdetails[0]?.Total).toFixed(2) +
        "</td></tr>";
      // }

      content += "</tbody>";
      content += "</table>";

      // Printing footer-
      // content += " " + clonedFooter.outerHTML;
      // content += " " + clonedFooter.style.borderBottom = "solid black";
      content += "</div>";
      // '<div style="border: 1px solid black; padding-bottom: 3rem;"></div>';
    }
    // setIsOriginal(false);

    let startI = 1;
    let endI = 10;

    for (var i = 1; i <= Math.ceil(salesItem.length / 10); i++) {
      // Printing page no-
      let pageNoElement = clonedHeader.querySelector("#page-no");
      pageNoElement.innerText = i;

      content +=
        ' <div style="text-align: end; font-size: 10px; font-weight:bold; width:580px; margin-top:2px ">Duplicate</div>';

      // Printing header-
      content += " " + clonedHeader.outerHTML;

      // Condition based Css-
      content +=
        '<div style="width: 580px; height: 280px; border-bottom: 1px solid black;">';
      // if (i > 1) {
      //   content +=
      //     '<div style="width: 580px "><p style="font-weight: bold; font-size: 7px; text-align: right;">Carry Over: ' +
      //     carryOverSum.toFixed(2) +
      //     "<p></div>";
      // }
      if (i == 1) {
        clonedHeader.style.marginTop = "1rem";
        // clonedFooter.style.marginTop = "1rem";
      }
      if (i > 1 && i != Math.ceil(salesItem.length / 10)) {
        // clonedFooter.style.marginTop = "1.4rem";
      }

      // Checking remaining Loops printing last footer-
      if (i == Math.ceil(salesItem.length / 10)) {
        let remainItems = Number(salesItem.length) % 10;
        let remainLoop = 10 - remainItems;

        // clonedFooter.style.marginTop = `${remainLoop * 1.9}rem`;
      }

      // Printing table body-
      content +=
        '<table style="font-size: 10px; margin-left: 1rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 8px;">S.No</th>' +
        '<th style="padding: 8px; width: 300px">Description</th>' +
        // '<th style="padding: 8px;">Barcode</th>' +
        '<th style="padding: 8px;">Quantity</th>' +
        '<th style="padding: 8px;">Price</th>' +
        '<th style="padding: 8px;">Discount%</th>' +
        // '<th style="padding: 8px;">Tax%</th>' +
        '<th style="padding: 8px;">Total</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex-
      for (let index = startI; index <= endI; index++) {
        if (index >= startI && index <= salesItem.length) {
          content +=
            "<tr>" +
            // First row
            "<tr>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px 0px 8px;  text-align: center;;">' +
            index +
            "</td>" +
            '<td colspan="6" style="font-size: 10px; font-weight: bold; padding: 0px 8px; z-index: 1; width: 560px">' +
            '<p style="font-size: 10px; font-weight: bold; font-weight: bold; margin: 0">' +
            salesItem[index - 1]?.ItemName +
            salesItem[index - 1].ItemVariationName +
            // <strong>{item?.ItemName}:</strong>
            // <strong>{item?.ItemVariationName}</strong>
            "</p>" +
            "<span>" +
            salesItem[index - 1].Itemnumber +
            "</span>" +
            "</td>" +
            "</tr>" +
            // Second row
            "<tr>" +
            // '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;"></td>' +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;"></td>' +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;"></td>' +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Quantity).toFixed(2) +
            "</td>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Price).toFixed(2) +
            "</td>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Discount).toFixed(2) +
            "</td>" +
            // '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            // Number(salesItem[index - 1].Tax).toFixed(2) +
            // "</td>" +
            '<td style="font-size: 10px; font-weight: bold; padding: 2px 8px;">' +
            Number(salesItem[index - 1].Total).toFixed(2) +
            "</td>" +
            "</tr>" +
            "</tr>";

          // Add the "Total" value to the carryOverSum on each page
          carryOverSum += Number(salesItem[index - 1].Total);
        }

        if (index % 10 == 0) {
          startI = startI + 10;
          endI = endI + 10;
          break;
        }
      }

      // Printing Total or Carry Sum condition based-
      // if (i !== Math.ceil(salesItem.length / 10)) {
      //   content +=
      //     '<tr><td colspan="12" style="text-align: right; padding-right: 10px; font-weight: bold;">Carry Over: ' +
      //     carryOverSum.toFixed(2) +
      //     "</td></tr>";
      // } else {
      content +=
        '<tr><td colspan="12" style="text-align: right; padding-top: 1rem; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Sub Total: ' +
        Number(salesdetails[0]?.SubTotal).toFixed(2) +
        "</td></tr>";

      // content +=
      //   '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Tax: ' +
      //   Number(salesdetails[0]?.Tax).toFixed(2) +
      //   "</td></tr>";

      content +=
        '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Discount: ' +
        Number(salesdetails[0]?.Discount).toFixed(2) +
        "</td></tr>";

      content +=
        '<tr><td colspan="12" style="text-align: right; padding-right: 10px; padding-bottom: 0.1rem; font-weight: bold;">Total: ' +
        Number(salesdetails[0]?.Total).toFixed(2) +
        "</td></tr>";
      // }

      content += "</tbody>";
      content += "</table>";

      // Printing footer-
      // content += " " + clonedFooter.outerHTML;
      // content += " " + clonedFooter.style.borderBottom = "solid black";
      content += "</div>";
      // '<div style="border: 1px solid black; padding-bottom: 3rem;"></div>';
    }

    setLoading(false);
    // Printing page-
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("JobWorkReceipt.pdf");
      },
    });
  };

  // const handleDownload = () => {
  //   var doc = new jsPDF("p", "pt", "a4");
  //   doc.html(document.querySelector("#print"), {
  //     callback: function (pdf) {
  //       pdf.save(`document.pdf`);
  //     },
  //   });
  // };

  // const convertToPDF = (content) => {
  //   console.log(content)
  //   const doc = new jsPDF();
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const pageHeight = doc.internal.pageSize.getHeight();
  //   let yPosition = 10;
  //   let contentChunks = [];

  //   // Split the content into chunks based on the page size
  //   const div = document.createElement('div');
  //   div.innerHTML = content;

  //   // Iterate through each child element
  //   for (let i = 0; i < div.children.length; i++) {
  //     const child = div.children[i];
  //     const childHeight = child.offsetHeight;

  //     // Check if the child element exceeds the page height
  //     if (yPosition + childHeight > pageHeight) {
  //       // Create a new page and reset the yPosition
  //       doc.addPage();
  //       yPosition = 10;
  //     }

  //     // Add the child element to the current page
  //     doc.fromHTML(child, 10, yPosition);
  //     yPosition += childHeight;
  //   }

  //   // Save the PDF
  //   doc.save('generated.pdf');
  // };

  // const handleDownload = () => {
  //   let content = document.querySelector("#print");
  //   convertToPDF(content);
  // };

  //Function for lookup receipt

  const paramObject = useParams();
  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    setLoading(true);

    axios
      .get(
        `${config.jobWorksBaseUrl}/jobworks/jobworkreceipt?id=${paramObject.id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log("responseDAta====372", res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setSalesDetails(res.data.ResponseData.SalesDetails);
          setSalesItem(res.data.ResponseData.SalesItems);
          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [paramObject.id]);

  //Function for export excel
  const handleExcelExport = () => {
    // console.log(responseData);
    const data = salesItem.length > 0 ? salesItem : [];

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `customers_details_.xlsx`);
    // setLoading(true);
    // axios
    //   .post(
    //     `${config.salesconfigBaseUrl}/sales/excelexport`,
    //     {
    //       salesid: paramObject.id,
    //     },
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         Authorization: token,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     console.log(res);
    //     toastSuccess(DATA_EXPORT);
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     toastError(ERROR_MESSAGE);
    //     setLoading(false);
    //   });
  };

  // to calculate the total
  // const calculateTotalSum = () => {
  //   const sum = responseData.SalesItems.reduce((total, item) => {
  //     const itemTotal = Number(item.Total);

  //     if (typeof itemTotal === "number" && !isNaN(itemTotal)) {
  //       return total + itemTotal;
  //     } else {
  //       return total;
  //     }
  //   }, 0);

  //   setTotalSum(sum);
  //   console.log(totalSum)
  // };

  // useEffect(() => {
  //   calculateTotalSum();
  // }, [responseData]);

  let sum;
  if (responseData.SalesItems || responseData.SalesItems !== undefined) {
    sum = responseData.SalesItems.reduce((total, item) => {
      return total + Number(item.Total);
    }, 0);
    sum = sum.toFixed(2);
  }
  console.log(sum);

  const handleUnSuspend = (pID) => {
    console.log("pID", pID);
    // localStorage.setItem("Clone", "Clone");
    //   axios
    //     .get(
    //       `${config.salesconfigBaseUrl}/sales/findbyid?id=${pID}`,

    //       {
    //         headers: {
    //           "Content-Type": "application/json;charset=UTF-8",
    //           "Access-Control-Allow-Origin": "*",
    //           Authorization: token,
    //         },
    //       }
    //     )
    //     .then((res) => {
    //       console.log("res from Suspended Receiving", res.data.ResponseData);
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
  };
  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);

  // Invoice Date-
  //   let invoiceDate;
  //   if (responseData.SalesDetails) {
  //     invoiceDate = new Date(responseData.SalesDetails[0]?.Date);
  //     invoiceDate = invoiceDate.toLocaleDateString();
  //   }
  //   console.log(invoiceDate);

  // Delivery Date-
  let deliveryDate;
  if (responseData.SalesDeliveryDetails) {
    if (responseData.SalesDeliveryDetails[0]?.Estimateddeliveryorpickupdate) {
      deliveryDate = new Date(
        responseData.SalesDeliveryDetails[0]?.Estimateddeliveryorpickupdate
      );
      deliveryDate = deliveryDate.toLocaleDateString();
    } else {
      deliveryDate = "";
    }
  }
  console.log(deliveryDate);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">JobWorks Receipt</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/jobworks">JobWorks</Link>
                </li>
                <li className="breadcrumb-item active">JobWorks Receipt</li>
              </ul>
            </div>
          </div>
          {/* <Link
            className="btn btn-sm btn-primary me-1 mb-5"
            to={`/manage-sales/${salesItem[0]?.SaleId}`}
          // onClick={handleUnSuspend()}
          >
            Edit
          </Link>

          <Link
            className="btn btn-sm btn-primary me-1 mb-5"
            to={`/sales-barcode-label/${salesItem[0]?.SaleId}`}
          >
            Barcode Labels
          </Link>
          <Link className="btn btn-sm btn-primary me-1 mb-5" onClick={downloadPdf}>
            Barcode Sheet
          </Link>
          <Link
            className="btn btn-sm btn-primary me-1 mb-5"
            onClick={handleExcelExport}
          >
            Excel Export
          </Link>
          <Link
            className="btn btn-sm btn-primary me-1 mb-5"
            to={`/manage-sales`}
            

            onClick={() => localStorage.setItem("Clone", salesItem[0]?.SaleId)}
         
          >
            Clone
          </Link> */}
          <Link
            className="btn btn-sm btn-primary me-1 mb-5"
            onClick={handlePrint}
          >
            Print
          </Link>
          <Link
            className="btn btn-sm btn-primary me-1 mb-5"
            onClick={handleDownload}
          >
            Download
          </Link>
          {/* Receipt */}
          {/* 
          <div className="card mt-5" id="print">
            <div className="card-body">
              <div className="row">
                <div className="col-md-4 ">
                  <div className="row">
                    <h6 className="fw-bold">
                      {responseData.CompanyDetails &&
                        responseData.CompanyDetails[0]?.CompanyName}
                    </h6>
                    <span style={{ width: "180px" }}>
                      {responseData.CompanyDetails &&
                        responseData.CompanyDetails[0]?.CompanyAddress}
                    </span>
                    <br />
                    <span>
                      {responseData.CompanyDetails &&
                        responseData.CompanyDetails[0]?.Website}
                    </span>
                  </div>
                  <div className="row mt-5">
                    <div className="col-md-12">
                      {responseData.CustomerDetails?.map((item, index) => {
                        return (
                          <div key={index}>
                            <span className="fw-bold">{item.Name}</span>
                            <br />
                            <span>{item.Companyname}</span>
                            <br />
                            <span>{item.Address}</span>
                            <br />
                            <span>{item.PhoneNumber}</span>
                            <br />
                            <span>{item.Country}</span>
                            <br />
                            <span>{item.Zip}</span>
                            <br />
                            <br />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  {responseData.CompanyDetails !== undefined &&
                  responseData.CompanyDetails[0]?.CompanyLogo !== "" ? (
                    <img
                      src={responseData.CompanyDetails[0]?.CompanyLogo}
                      alt={responseData.CompanyDetails[0]?.CompanyName}
                    />
                  ) : (
                    <h4 className="fw-bold">Sonar POS</h4>
                  )}
                </div>

                <div className="col-md-4 ">
                  <div className="row">
                    <div className="col-md-4">
                      <h6 className="fw-bold">Original</h6>
                    </div>
                    <div className="col-md-8">
                      <h6 className="fw-bold">Order Confirmation</h6>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row mt-2 d-flex justify-content-between">
                          <div className="col-md-auto">
                            <p>Invoice No:</p>
                            {responseData.SalesDetails &&
                              responseData.SalesDetails[0]?.InvoiceNo}
                          </div>
                          <div className="col-md-auto">
                            <p>Invoice Date:</p>
                            {invoiceDate}
                          </div>
                          <div className="col-md-auto">
                            <p>Page No:</p>
                            {currentPage}/{totalPages === true ? totalPages : 1}
                          </div>
                        </div>
                        <hr />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row ">
                          <div className="col-md-4">
                            <p>Customer No:</p>
                            {responseData.SalesDetails &&
                              responseData.SalesDetails[0]?.Customerid}
                          </div>
                          <div className="col-md-8">
                            Federal Tax ID - Business Partner
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-12">
                            <p>Your Reference</p>
                            {responseData.CustomerDetails &&
                              responseData.CustomerDetails[0]?.InternalNotes}
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-12">
                            <p>Your Contact</p>
                            {responseData.CustomerDetails &&
                              responseData.CustomerDetails[0]?.PhoneNumber}
                          </div>
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-md-12">
                            <span className="fw-bold">Delivery Address</span>
                            <br />
                            <span>
                              {responseData.SalesDeliveryDetails &&
                                responseData.SalesDeliveryDetails[0]
                                  ?.FirstName}{" "}
                              {responseData.SalesDeliveryDetails &&
                                responseData.SalesDeliveryDetails[0]?.LastName}
                            </span>
                            <br />
                            <span>
                              {responseData.SalesDeliveryDetails &&
                                responseData.SalesDeliveryDetails[0]?.Address1}
                            </span>
                            <br />
                            <span>
                              {responseData.SalesDeliveryDetails &&
                                responseData.SalesDeliveryDetails[0]?.Address2}
                            </span>
                            <br />
                            <span>
                              {responseData.SalesDeliveryDetails &&
                                responseData.SalesDeliveryDetails[0]?.City}
                              ,{" "}
                              {responseData.SalesDeliveryDetails &&
                                responseData.SalesDeliveryDetails[0]?.State}
                              ,{" "}
                              {responseData.SalesDeliveryDetails &&
                                responseData.SalesDeliveryDetails[0]?.Country}
                            </span>
                            <br />
                            <span>
                              {responseData.SalesDeliveryDetails &&
                                responseData.SalesDeliveryDetails[0]?.Zip}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr />
              <div className="row mb-2 d-flex justify-content-between">
                <div className="col-md-auto">
                  <p>Delivery Date: {deliveryDate}</p>
                </div>
                <div className="col-md-auto">
                  <p>Currency: $</p>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table mt-2">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Description</th>
                      <th>Barcode</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>Discount %</th>
                      <th>Tax %</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {responseData.SalesItems?.map((item, index) => {
                      const individualTotal =
                        parseFloat(item.Quantitypurchased) *
                        parseFloat(item.Itemunitprice);
                      return (
                        <tr key={index}>
                          <td style={{ textAlign: "left" }}>
                            {++index}
                            &nbsp; &nbsp; &nbsp;
                          </td>

                          <td>
                            <strong>{item.ItemName} </strong> (
                            {item.ItemVariationName !== null
                              ? item.ItemVariationName
                              : null}
                            )
                            <br />
                            <small className="d-flex justify-content-start align-items-center">
                              <span>Item Number:</span>
                              <span>{item.Itemnumber}</span>
                            </small>
                          </td>

                          <td></td>

                          <td>${Number(item.Itemunitprice).toFixed(2)}</td>

                          <td>{Number(item.Quantitypurchased).toFixed(2)}</td>

                          <td>{Number(item.Discountpercent).toFixed(2)}</td>

                          <td>{Number(item.Tax).toFixed(2)}</td>

                          <td>{Number(item.Total).toFixed(2)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                <div className="mt-2 w-100" style={{ textAlign: "right" }}>
                  <p className="fw-bold">
                    Sub Total: ${Number(salesdetails[0]?.Subtotal).toFixed(2)}
                  </p>
                </div>

                <div className="mt-2 w-100" style={{ textAlign: "right" }}>
                  <p className="fw-bold">
                    Tax: ${Number(salesdetails[0]?.Tax).toFixed(2)}
                  </p>
                </div>

                <div className="mt-2 w-100" style={{ textAlign: "right" }}>
                  <p className="fw-bold">
                    Discount: $
                    {Number(salesdetails[0]?.Discountentiresale).toFixed(2)}
                  </p>
                </div>

                <div className="mt-2 w-100" style={{ textAlign: "right" }}>
                  <p className="fw-bold">
                    Total Amount: ${Number(salesdetails[0]?.Total).toFixed(2)}
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <span>CEO:</span>
                  <br />
                  <span>Shareholder:</span>
                  <br />
                  <span>Tax Official</span>
                  <br />
                  <span>Headquarters:</span>
                  <br />
                  <span>Website:</span>
                  <br />
                </div>
                <div className="col-md-4">
                  <span>Phone:</span>
                  <br />
                  <span>Fax:</span>
                  <br />
                  <span>E-Mail:</span>
                  <br />
                  <span>Tax No.:</span>
                  <br />
                  <span>Tax ID No.:</span>
                  <br />
                </div>
                <div className="col-md-4">
                  <span>Bank Name:</span>
                  <br />
                  <span>Bank Account:</span>
                  <br />
                  <span>Routing Code:</span>
                  <br />
                  <span>Swift/BIC Code:</span>
                  <br />
                  <span>IBAN:</span>
                  <br />
                </div>
              </div>
            </div>
          </div> */}

          {/* Sales Receipt */}
          <div id="print" className="form-control">
            <div className="card-body">
              {/* Header */}
              <div className="fw-bold" style={{ textAlign: "end" }}>
                Original
              </div>
              <div id="header">
                <div style={{ color: "#000!important" }}>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="fw-bold">Invoice</div>
                      <div className="row fw-bold">
                        <span>
                          Customer No :{" "}
                          {responseData?.SalesDetails &&
                            responseData?.SalesDetails[0]?.CustomerId}
                        </span>
                        {/* <br /> */}

                        {responseData?.CustomerDetails?.map((item, index) => {
                          return (
                            <>
                              <span>{item?.Name}</span>
                              {item?.Companyname.trim() &&
                                item?.Companyname.trim() != "" && (
                                  <>
                                    <br />
                                    <span>{item?.Companyname}</span>
                                  </>
                                )}
                              {item?.Address.trim() &&
                                item?.Address.trim() != "" && (
                                  <>
                                    <br />
                                    <span>{item?.Address}</span>
                                  </>
                                )}
                              {item?.Country.trim() &&
                                item?.Country.trim() != "" && (
                                  <>
                                    <br />
                                    <span>{item?.Country}</span>
                                  </>
                                )}
                              {item?.Zip != "0" && (
                                <>
                                  <br />
                                  <span>{item?.Zip}</span>
                                </>
                              )}
                              {item?.PhoneNumber != "0" && (
                                <>
                                  <br />
                                  <span>
                                    Your Contact : {item?.PhoneNumber}
                                  </span>
                                </>
                              )}

                              {/* <br />
                            <span>{item?.Companyname}</span>
                            <br />
                            <span>{item?.Address}</span>
                            <br />
                            <span>{item?.Country}</span>
                            <br />
                            <span>{item?.Zip}</span><br />
                            <span>{item?.PhoneNumber != "0" ? item?.PhoneNumber : ""}
                         
                        </span> */}
                            </>
                          );
                        })}
                      </div>
                    </div>

                    <div className="col-md-4 ">
                      <div className="">
                        {responseData?.CompanyDetails !== undefined &&
                        responseData?.CompanyDetails[0]?.CompanyLogo !== "" ? (
                          <img
                            src={responseData?.CompanyDetails[0]?.CompanyLogo}
                            alt={responseData?.CompanyDetails[0]?.CompanyName}
                            width="100px"
                            height="auto"
                          />
                        ) : (
                          <h3 className="fw-bold">Jarkan</h3>
                        )}
                      </div>
                      <span className="fw-bold">
                        {responseData?.CompanyDetails &&
                          responseData?.CompanyDetails[0]?.CompanyName}
                      </span>
                      {/* <br />
                      <span> {responseData?.CompanyDetails && responseData?.CompanyDetails[0]?.CompanyAddress}</span>
                      <br />
                      <span>{responseData?.CompanyDetails && responseData?.CompanyDetails[0]?.Website}</span>
                      <br /> <br />  */}

                      {/* <div className="row">
                        <div className="col-md-12">
                          <span className="fw-bold">Delivery Address</span>
                          <br />
                          <span>
                            {responseData?.CustomerDetails &&
                              responseData?.CustomerDetails[0]
                                ?.ShippingAddress}{" "}
                            
                          </span>
                          
                        </div>
                      </div> */}
                    </div>

                    <div className="col-md-4">
                      <div className="row">
                        {/* <div className="col-md-4">
                          <p className="fw-bold" style={{ margin: 0 }}>
                            Original
                          </p>
                        </div>
                        <div className="col-md-8">
                          <p className="fw-bold" style={{ margin: 0 }}>
                            Order Confirmation
                          </p>
                        </div> */}
                        <div className="row">
                          <div className="d-flex gap-4">
                            <div className="row">
                              No:{" "}
                              {responseData?.SalesDetails &&
                                responseData?.SalesDetails[0]?.InvoiceNo}
                              -Job Work
                            </div>
                            <div className="d-flex">
                              Page No:{" "}
                              <div className="" id="page-no">
                                {currentPage && currentPage}
                              </div>
                              /{totalPages === true ? totalPages : 1}
                            </div>
                          </div>
                          <div className="row">
                            Date:{" "}
                            {responseData?.SalesDetails &&
                              moment(
                                responseData?.SalesDetails[0]?.Date
                              ).format("DD-MM-yyyy")}
                          </div>

                          {/* <div className="d-flex">
                           

                              <div className="col-md-5">
                                <p style={{ margin: 0 }}>
                                  Date:
                                  <br />
                                  {responseData?.SalesDetails &&
                                    moment(
                                      responseData?.SalesDetails[0]?.Date
                                    ).format("DD-MM-yyyy")}
                                </p>
                              </div>
                              <div className="col-md-4">
                                <label>Page No:</label>
                                <p style={{ margin: 0 }}>
                                  <label id="page-no">
                                    {currentPage && currentPage}
                                  </label>
                                  /{totalPages === true ? totalPages : 1}
                                </p>
                              </div> */}
                          {/* </div> */}
                          {/* <hr /> */}
                          {/* </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid #282828",
                    margin: "1rem 0",
                  }}
                ></div>
                {/* <hr /> */}
                {/* <div className="d-flex justify-content-between">
                  <p style={{ fontWeight: "bold" }}>
                    Delivery Date : {deliveryDate && deliveryDate}
                  </p>
                  <p style={{ fontWeight: "bold" }}>Currency : ₹</p>
                </div> */}
              </div>

              {/* Body */}
              <div className="table-responsive" id="body">
                <table className="table mt-1">
                  <thead>
                    <tr>
                      <th className="col-md">S.No</th>
                      <th className="col-md-3">Description</th>
                      {/* <th className="col-md-2" style={{ textAlign: "center" }}>
                        Barcode
                      </th> */}
                      <th className="col-md-2" style={{ textAlign: "right" }}>
                        Price
                      </th>
                      <th className="col-md-2" style={{ textAlign: "right" }}>
                        Quantity
                      </th>
                      <th className="col-md-2" style={{ textAlign: "right" }}>
                        Discount %
                      </th>
                      {/* <th className="col-md-2" style={{ textAlign: "right" }}>
                        Tax %
                      </th> */}
                      <th className="col-md-2" style={{ textAlign: "right" }}>
                        Total
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {responseData?.SalesItems?.map((item, index) => {
                      return (
                        <>
                          <tr key={index}>
                            <td className="col-md">{++index}</td>

                            <td
                              style={{ textAlign: "left" }}
                              className="col-md-2"
                            >
                              <small className="col-md-2">
                                <strong>{item?.ItemName}:</strong>
                                <strong>{item?.ItemVariationName}</strong>
                              </small>
                              <p>
                                Item Number:
                                {item.Itemnumber}
                              </p>
                            </td>

                            {/* <td></td> */}

                            <td
                              className="col-md-2"
                              style={{ textAlign: "right" }}
                            >
                              ₹{Number(item.Price).toFixed(2)}
                            </td>

                            <td
                              className="col-md-2"
                              style={{ textAlign: "right" }}
                            >
                              {Number(item.Quantity).toFixed(2)}
                            </td>

                            <td
                              className="col-md-2"
                              style={{ textAlign: "right" }}
                            >
                              {Number(item.Discount).toFixed(2)}
                            </td>

                            {/* <td
                              className="col-md-2"
                              style={{ textAlign: "right" }}
                            >
                              {Number(item.Tax).toFixed(2)}
                            </td> */}

                            <td
                              className="col-md-2"
                              style={{ textAlign: "right" }}
                            >
                              {Number(item.Total).toFixed(2)}
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>

                <div style={{ textAlign: "right" }} className="mt-3">
                  <p style={{ margin: "0" }}>
                    <strong>Sub Total: </strong>₹
                    {Number(salesdetails[0]?.SubTotal).toFixed(2)}
                  </p>
                  {/* <p style={{ margin: "0" }}>
                    <strong>Tax : </strong>₹
                    {Number(salesdetails[0]?.Tax).toFixed(2)}
                  </p> */}
                  <p style={{ margin: "0" }}>
                    <strong>Discount: </strong>₹
                    {Number(salesdetails[0]?.Discount).toFixed(2)}
                  </p>
                  <p style={{ margin: "0" }}>
                    <strong>Total Amount: </strong>₹
                    {Number(salesdetails[0]?.Total).toFixed(2)}
                  </p>
                </div>
                <hr />
              </div>

              {/* Footer */}
              <div className="row" id="footer">
                <div className="col-md-4">
                  <span>CEO:</span>
                  <br />
                  <span>Shareholder:</span>
                  <br />
                  <span>Tax Official</span>
                  <br />
                  <span>Headquarters:</span>
                  <br />
                  <span>Website:</span>
                  <br />
                </div>
                <div className="col-md-4">
                  <span>Phone:</span>
                  <br />
                  <span>Fax:</span>
                  <br />
                  <span>E-Mail:</span>
                  <br />
                  <span>Tax No.:</span>
                  <br />
                  <span>Tax ID No.:</span>
                  <br />
                </div>
                <div className="col-md-4">
                  <span>Bank Name:</span>
                  <br />
                  <span>Bank Account:</span>
                  <br />
                  <span>Routing Code:</span>
                  <br />
                  <span>Swift/BIC Code:</span>
                  <br />
                  <span>IBAN:</span>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "none" }}>
        {responseData.SalesItems?.map((item) => (
          <>
            <div key={item.SaleId}>
              <canvas
                data-name={item.SaleId}
                ref={(el) => (barcodeRefs.current[item.SaleId] = el)}
                id={`barcode-${item.SaleId}`}
              />
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default JobWorkReceipt;
